import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconSortFilter24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="sort filter">
            <path
                d="M5.99999 5.00001C6.55226 5.00002 6.99999 5.44773 6.99999 6.00001C6.99999 6.55229 6.55226 7 5.99999 7.00001H3.33202L10.5019 14.5361C10.6788 14.722 10.7773 14.9691 10.7773 15.2256V19.2051L13.2226 21.0156V15.2256C13.2227 14.9691 13.3212 14.722 13.498 14.5361L20.668 7.00001H18C17.4477 7.00001 17 6.55229 17 6.00001C17 5.44773 17.4477 5.00001 18 5.00001H23C23.3998 5.00002 23.7612 5.23813 23.9189 5.60548C24.0766 5.97304 24.0003 6.39972 23.7246 6.68946L15.2226 15.624V23C15.2226 23.3777 15.0091 23.7226 14.6719 23.8926C14.3346 24.0625 13.9304 24.0284 13.6269 23.8037L9.1826 20.5137C8.92794 20.3251 8.77742 20.0268 8.77733 19.71V15.624L0.275376 6.68946C-0.000299633 6.39972 -0.0765938 5.97304 0.0810405 5.60548C0.238758 5.23812 0.600181 5.00001 0.999986 5.00001H5.99999Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11.3691 0.224619C11.7619 -0.0957571 12.3409 -0.0731082 12.707 0.292979L15.707 3.29298C16.0975 3.6835 16.0975 4.31652 15.707 4.70704C15.3165 5.09754 14.6835 5.09756 14.293 4.70704L13 3.41407V8.58595L14.293 7.29298C14.6835 6.90246 15.3165 6.90248 15.707 7.29298C16.0975 7.6835 16.0975 8.31652 15.707 8.70704L12.707 11.707C12.6592 11.7548 12.6064 11.7976 12.5498 11.835C12.5121 11.8599 12.4727 11.8811 12.4326 11.9004C12.388 11.9219 12.3419 11.9403 12.2939 11.9551C12.2682 11.963 12.242 11.9688 12.2158 11.9746C12.2096 11.976 12.2035 11.9782 12.1973 11.9795C12.1782 11.9833 12.1589 11.9856 12.1396 11.9883C12.0939 11.9947 12.0475 12 12 12C11.9515 12 11.904 11.995 11.8574 11.9883C11.8388 11.9856 11.8202 11.9832 11.8017 11.9795C11.7906 11.9773 11.7796 11.9743 11.7685 11.9717C11.748 11.9668 11.7273 11.9623 11.707 11.9561C11.6584 11.9412 11.6116 11.9222 11.5664 11.9004C11.5266 11.8812 11.4877 11.8597 11.4502 11.835C11.3935 11.7976 11.3408 11.7548 11.293 11.707L8.29295 8.70704C7.90243 8.31652 7.90243 7.6835 8.29295 7.29298C8.68348 6.90248 9.3165 6.90246 9.70702 7.29298L11 8.58595V3.41407L9.70702 4.70704C9.3165 5.09756 8.68348 5.09754 8.29295 4.70704C7.90243 4.31652 7.90243 3.6835 8.29295 3.29298L11.293 0.292979C11.3174 0.268573 11.3429 0.245974 11.3691 0.224619Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconSortFilter48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="sort filter">
            <path
                d="M12 12H4L19.5556 28.4516V39.4194L28.4444 46V28.4516L44 12H36"
                stroke={props.fill || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23 22C23 22.5523 23.4477 23 24 23C24.5523 23 25 22.5523 25 22H24H23ZM24 22H25V2H24H23V22H24Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M24 22L18 16"
                stroke={props.fill || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M24 22L30 16"
                stroke={props.fill || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M24 2L30 8"
                stroke={props.fill || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M24 2L18 8"
                stroke={props.fill || 'currentColor'}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}
